<template>
  <div class="jd-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="130"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="下单时间"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===2&&scope.row.type===2" type="danger">售后驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===2&&scope.row.type===3" type="danger">评估驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===2&&scope.row.type!==3&&scope.row.type!==2" type="warning">待接单</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-document" @click.stop="accept(scope.row)">立即接单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="接单"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分配类型" prop="issplit" v-if="editForm.type===3">
          <el-radio-group v-model="editForm.issplit">
            <el-radio :label="0">技术评估</el-radio>
            <el-radio :label="1">自主拆单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预估价格" prop="price">
          <el-input v-model="editForm.price" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type===4" label="售后内容" prop="after">
          <el-input v-model="editForm.after" type="textarea" maxlength="300" show-word-limit/>
        </el-form-item>
        <el-form-item v-if="editForm.type===0" label="报备关联" prop="reportid">
          <el-cascader
            v-model="editForm.reportid"
            :options="reportList"
            style="width:100%"
            filterable
            clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="接单备注" prop="content">
          <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">立即接单</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="editloading" @click="turn('editForm')">驳回</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, acceptOrder, getDealerAccountReportByDelid } from '@/api/erp'
import { getBrandList } from '@/api/work'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'jd',
  computed: {
    user: getUser
  },
  components: {
    MultiFile,
    MultiImg
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      editForm: {
        price: null,
        orderid: '',
        ordername: '',
        type: null,
        issplit: null,
        content: '',
        files: [],
        imgids: [],
        after: '',
        reportid: []
      },
      editRules: {
        price: [{ required: true, message: '请输入预估价格', trigger: 'blur' }],
        issplit: [{ required: true, message: '请选择分配类型', trigger: 'change' }],
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        after: [{ required: true, message: '请在这里填写售后内容', trigger: 'blur' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: [],
      reportList: []
    }
  },
  created() {
    this.getData()
    this.getBrandList()
  },
  methods: {
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: 2,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    accept(row) {
      this.editRules.content[0].required = false
      this.editRules.price[0].required = true
      this.editRules.after[0].required = true
      this.editRules.issplit[0].required = true
      this.editForm.price = null
      this.editForm.after = null
      if (row.mark === 3) {
        this.editForm.issplit = null
      } else {
        this.editForm.issplit = 0
      }
      this.editForm.orderid = row.order_id
      this.editForm.type = row.mark
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.reportid = []
      if (this.editForm.type === 0) {
        getDealerAccountReportByDelid({ delid: row.delid, groupid: row.groupid }).then(response => {
          let rslst = []
          for (const d of response.data) {
            let children = []
            for (const a of d.daralst) {
              if (a.orderid !== null && a.orderid !== '' && a.orderid !== undefined) {
                if (a.orderid === this.editForm.orderid) {
                  children.push({ value: a.id, label: a.address })
                  this.editForm.reportid = [d.darid, a.id]
                } else {
                  children.push({ value: a.id, label: a.address + '（已关联）', disabled: true })
                }
              } else {
                children.push({ value: a.id, label: a.address })
              }
            }
            rslst.push({ value: d.darid, label: d.name, children: children })
          }
          this.reportList = rslst
        }).catch(() => {
          this.reportList = []
        })
      } else {
        this.reportList = []
      }
      this.editVisible = true
    },
    turn(formName) {
      this.editRules.content[0].required = true
      this.editRules.issplit[0].required = false
      this.editRules.price[0].required = false
      this.editRules.after[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAcceptOrder(0)
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.editRules.price[0].required = true
      this.editRules.issplit[0].required = true
      this.editRules.after[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAcceptOrder(1)
        } else {
          return false
        }
      })
    },
    SubAcceptOrder(ispass) {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          type: this.editForm.type,
          content: this.editForm.content,
          ispass: ispass,
          fileids: this.editForm.files.join(','),
          imgids: this.editForm.imgids.join(','),
          price: this.editForm.price,
          after: this.editForm.after,
          reportid: this.editForm.reportid.join(','),
          issplit: this.editForm.issplit
        }
        acceptOrder(data).then(response => {
          let msg = '接单操作成功'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jd-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
